import React, { useEffect, useState } from 'react'
import Header from '../header/Header'
import Footer from '../footer/Footer';
import { MdVideoLibrary } from "react-icons/md";
import img1 from '../../Assests_Url/image-teach.png'
import img2 from '../../Assests_Url/image-video.png'
// import Interactive from '../../Assests_Url/InterExer.png'
import ques from '../../Assests_Url/question.png'
import pers from '../../Assests_Url/gridicons.png'
import aisearch from '../../Assests_Url/ai.png'
import coverage from '../../Assests_Url/cov-report.png'
import mul_search from '../../Assests_Url/multi-search.png'
import { RiVolumeUpFill } from "react-icons/ri";
import { PiExamFill } from "react-icons/pi";
import { FaLanguage } from "react-icons/fa6";

import video1 from '../../Assests_Url/Interactive Exercises.mp4'
import video2 from '../../Assests_Url/Personalisation.mp4'
import video3 from '../../Assests_Url/Dictionary_Translator.mp4'
import video4 from '../../Assests_Url/Multiple_ai.mp4'
import video5 from '../../Assests_Url/COVERAGE_REPORT.mp4'
import video6 from '../../Assests_Url/Multi_Search.mp4'
import video7 from '../../Assests_Url/CONCEPT_AND_EXPLANATION_VIDEO.mp4'
import video8 from '../../Assests_Url/AUDIO_ON_TOUCH.mp4'
import { IoArrowUndoCircle } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';



const UTeachFoundation = ({ RoutesClick, NcertClick }) => {
  const [registerModal, setRegisterModal] = useState(false);
  const [activeTabHeader, setActiveTabHeader] = React.useState("KATBOOK");
  const [studentregisterModal, setStudentRegisterModal] = useState(false);
  const [ParentregisterModal, setParentRegisterModal] = useState(false);
  const [TeacherregisterModal, setTeacherregisterModal] = useState(false);

  const handleTabClickHeader = (tab) => {
    setActiveTabHeader(tab);
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate()

  return (
    <div>
      <div>
        <Header
          activeTab={activeTabHeader}
          handleTabClick={handleTabClickHeader}
          studentregisterModal={studentregisterModal}
          setStudentRegisterModal={setStudentRegisterModal}
          ParentregisterModal={ParentregisterModal}
          setParentRegisterModal={setParentRegisterModal}
          TeacherregisterModal={TeacherregisterModal}
          setTeacherregisterModal={setTeacherregisterModal}
          registerModal={registerModal}
          setRegisterModal={setRegisterModal}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>

      <div className='container-uteach'>
        <div className='pt-5'>
          <div className='d-flex align-items-center justify-content-between text-center pb-4'>
            <div>
              <IoArrowUndoCircle size={30} className='back-arrow'
                onClick={() => {
                  navigate("/katbook", { state: { scroll: "bottom" } });
                }}
              />
            </div>
            <div className='found-font'>
              UTeach Foundation Level
            </div>
            <div></div>
          </div>

          <div className='d-flex flex-column align-items-center gap-3'>
            <div className='meta-font'>
              The Power of Meta Content
            </div>
            <div className='text-foun-font text-center'>
              NCERT KATBOOKS are powered by state-of-the-art additional
              teaching resources curated by Subject Matter Experts and top
              content creators from across the globe.
            </div>
            <div className='text-foun-font text-center'>
              Teachers can use these ready-to-use additional digital
              resources to teach in the classroom and improve concept
              understanding for complex topics.
            </div>
          </div>

          <div className='pt-5'>
            <div className='d-flex flex-column gap-5'>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='d-flex align-items-center gap-3 cont-heading'>
                    1. Embedded Videos (Concept & Explanation) <MdVideoLibrary size="25" />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Videos are embedded from the KATBOOK itself to explain difficult or
                    important concepts. By tapping on the play button, a concept video
                    starts directly inside the book window, without redirecting to YouTube
                    or any external platform. Teachers can pause, replay, or project it in
                    full screen. Longer concept videos are available with timestamps for
                    focused teaching.

                    <ul>
                      <li>
                        It acts as a ready-made visual teaching aid for abstract or
                        tough concepts, making class more interactive.
                      </li>
                      <li>
                        Saves preparation time — no need to source or create separate videos
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video7} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='d-flex align-items-center gap-3 cont-heading'>
                    2. Interactive Exercise <PiExamFill size={25} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    At the end of various sessions, interactive exercises are available
                    in the KATBOOK. Teachers can launch interactive activities like draw
                    and color, drag-and-drop, or matching tasks. In a classroom, teachers
                    can ask students to come up to the smartboard and complete the
                    interactive exercise.

                    <ul>
                      <li>
                        Promotes self learning
                      </li>
                      <li>
                        Children love to tap and explore and this functionality improves classroom participation
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video1} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='d-flex align-items-center gap-3 cont-heading'>
                    3. Interactive Quizzes in KATBOOK <img src={ques} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    KATBOOK comes with a wide range of built-in quizzes — including
                    multiple choice, fill-in-the-blanks, and short or long answer formats.
                    Teachers can seamlessly use these quizzes during classroom sessions to
                    make learning more engaging while conducting real-time evaluations.

                    <ul>
                      <li>
                        Teachers can launch quizzes live during lessons for instant evaluation,
                        keeping students active, involved, and excited to learn
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    <img src={img2} alt='found-video' className='img-video' />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex flex-column align-items-center gap-3 pt-5'>
            <div className='meta-font'>
              INTERACTIVE FEATURES OF KATBOOK
            </div>
            <div className='text-foun-font text-center'>
              At U-Educate, we believe that education should go beyond textbooks - it
              should inspire curiosity, foster understanding, and support every learner’s
              unique journey. NCERT KATBOOKs transform traditional learning materials into
              a dynamic and interactive experience that empowers both teachers and students.
            </div>
            <div className='text-foun-font text-center'>
              Foundational books are equipped with Audio Book mode that can be
              toggled on and off from the top.
            </div>
          </div>

          <div className='pt-5'>
            <div className='d-flex flex-column gap-5'>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='d-flex align-items-center gap-3 cont-heading'>
                    1. Audio Book Mode: ON <RiVolumeUpFill size={"20px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    When switched on, teachers can simply tap on any word/sentence, and
                    the stories or poems come to life with audio.

                    <ul>
                      <li>
                        Quickly teaches right pronunciation and makes
                        the sessions interactive.
                      </li>
                      <li>
                        Helps in multilingual classrooms
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video8} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='d-flex align-items-center gap-2 cont-heading'>
                    2. Personalisation <img src={pers} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Teachers can highlight key passages, add notes for reference,
                    and bookmark lessons from within the KATBOOK itself

                    <ul>
                      <li>
                        Acts like a digital teaching diary.
                      </li>
                      <li>
                        Helps in lesson planning and revision.
                      </li>
                      <li>
                        Easy to guide students by sharing highlights.
                      </li>
                      <li>
                        Improves classroom organization.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video2} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    3. Inbuilt Dictionary & Translator <FaLanguage size={"25px"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Teachers can simply highlight any word for instant meaning from the
                    in-built dictionary to make children understand the meaning of difficult
                    terms. With an in-built translator, teachers can translate the entire
                    book or even particular words/text in the preferred language of the
                    region. No external apps needed.

                    <ul>
                      <li>
                        Improves vocabulary and comprehension.
                      </li>
                      <li>
                        Helps in learning without external help.
                      </li>
                      <li>
                        Supports bilingual learning.
                      </li>
                      <li>
                        Bridges gaps in diverse classrooms.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video3} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    4. AI Search <img src={aisearch} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Another revolutionary feature in-built in the KATBOOK is AI Search.
                    With the help of AI Search, teachers can highlight any part of the
                    book and ask various AI Modules to generate a summary or synopsis for
                    that particular highlighted part of the book. They can even generate
                    Q&A or any other specific information that you may seek.

                    <ul>
                      <li>
                        Quick fact-checking during class.
                      </li>
                      <li>
                        Access to multiple resources in one place.
                      </li>
                      <li>
                        Improves lesson enrichment.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video4} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    5. Coverage Report <img src={coverage} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    Once connected with KAMPUS during a full scale roll-out on a school
                    level, Teachers will be able to see chapter coverage, exercises
                    completed, and overall book progress for each student in her dashboard.

                    <ul>
                      <li>
                        Tracks class progress automatically.
                      </li>
                      <li>
                        Identifies weaker learners early.
                      </li>
                      <li>
                        Supports data-driven teaching.
                      </li>
                      <li>
                        Ensures syllabus completion on time.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video5} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

              <div>
                <div className='d-flex flex-column gap-3'>
                  <div className='cont-heading'>
                    6. Multiple Search <img src={mul_search} width={"2%"} />
                  </div>
                  <div className='cont-para d-flex flex-column gap-2'>
                    In case the teacher wants more information on any particular subject
                    that is not available as additional content, we have provided the
                    KATBOOK with a revolutionary MULTIPLE SEARCH FEATURE. Teachers can
                    highlight and select any word or any part of the text from the KATBOOK
                    and navigate to multiple search option where they can find information
                    from multiple sources.

                    <ul>
                      <li>
                        Various AIs like chatgpt, gemini, perplexity etc.
                      </li>
                      <li>
                        Various Web Browsers.
                      </li>
                      <li>
                        Various Encyclopedias like wikipedia, brittanica.
                      </li>
                      <li>
                        Various dictionaries like merriam or oxford.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-center gap-3 w-100'>
                  {/* img */}
                  <div>
                    <img src={img1} alt='found-img' className='img-video' />
                  </div>

                  {/* Video */}
                  <div>
                    {/* <img src={img2} alt='found-video' className='img-video' /> */}
                    <video className='video-css'
                      width="540"
                      controls
                    >
                      <source src={video6} type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className='d-flex flex-column align-items-center gap-3 pt-5 pb-3'>
            <div className='meta-font'>
              TEACHER’S HANDBOOK
            </div>
            <div className='text-foun-font text-center'>
              UTeach version of KATBOOK comes with a built-in Teacher’s
              Handbook section if provided by the board. Accessible via
              KATBOOK, it includes lesson objectives, suggested teaching
              strategies, activity ideas, assessment guidelines, and tips
              for differentiated instruction.
            </div>
            <div className='text-foun-font text-center'>
              This benefits as a ready-made teaching guide aligned with curriculum
              standards and Supports new or less experienced teachers with
              step-by-step guidance.
            </div>
          </div>

        </div>
      </div>

      <div>
        <Footer
          setActiveTab={setActiveTabHeader}
          RoutesClick={RoutesClick}
          NcertClick={NcertClick}
        />
      </div>
    </div>
  )
}

export default UTeachFoundation
